import { keysToCamelCase } from '@hotjar/webapp/lib/convert-string';
import type { UserPersonalizationInfoDto, UserPersonalizationInfo } from './types';

export function mapDtoToModel(dto: UserPersonalizationInfoDto): UserPersonalizationInfo {
  return keysToCamelCase(dto);
}
